import { createSelector } from 'reselect';
import { RootState } from 'stores/reducers';

const getConfiguratorDomain = (state: RootState) => state.domains.configurator;

export const getCustomerId = createSelector(
  getConfiguratorDomain,
  configuratorDomain => configuratorDomain.id
);

export const getCustomerIdIsLoading = createSelector(
  getConfiguratorDomain,
  configuratorDomain => configuratorDomain.loading
);

export const getCustomerIdIsLoaded = createSelector(
  getConfiguratorDomain,
  configuratorDomain => configuratorDomain.loaded
);
